import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import  * as AWS from "aws-sdk";
import { environment } from '../environments/environment';
import {
  UserService
} from '../app/_services/index';

@Injectable({
  providedIn: 'root'
})
export class S3ServiceService {
  private bucket;
  private s3;
  constructor(private http: HttpClient, public userService: UserService ) {

    AWS.config.update({
      region: environment.AWS_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.IDENTITY_POOL_ID
      })
    });
    
    this.bucket = new AWS.S3({
      apiVersion: "2006-03-01",
      params: { Bucket: environment.RESUME_BUCKET_NAME }
    });

    this.s3 = new AWS.S3();
  }

  async uploadFile(file: File) {
    
    let resumeLocation = `${this.userService.getCurrentUser()._id}/${file.name}`;

    let params = {
      Body        : file, 
      Bucket      : environment.RESUME_BUCKET_NAME, 
      Key         : `${resumeLocation}`,
      ContentType : file.type
    };
    return new Promise((resolve, reject) => {
      try {
        this.bucket.putObject(params, function(err, data) {
          if(err){ 
            console.log(err, err.stack,'File Error Data'); // an error occurred
            reject()
          }else{
            console.log(data,'File Data');           // successful response
            resolve(`${resumeLocation}`)
          }
        });
      } catch(error) {
        console.log("FAILURE", error);
        reject()
      }
    })
  }

  async uploadProfile(file: File) {
    
    let resumeLocation = `${this.userService.getCurrentUser()._id}/${file.name}`;

    let params = {
      Body        : file, 
      Bucket      : environment.PROFILE_BUCKET_NAME, 
      Key         : `${resumeLocation}`,
      ContentType : file.type
    };
    return new Promise((resolve, reject) => {
      try {
        this.bucket.putObject(params, function(err, data) {
          if(err){ 
            console.log(err, err.stack,'File Error Data'); // an error occurred
            reject()
          }else{
            console.log(data,'File Data');           // successful response
            resolve(`${resumeLocation}`)
          }
        });
      } catch(error) {
        console.log("FAILURE", error);
        reject()
      }
    })
  }
 
}
